import { TCityConfig } from "@/@core/services/interfaces/covarege-area/city/ICityService";

const cityConfig: TCityConfig = {
  //Endpoints
  getCityByIdEndpoint: "/api/AreasAbrangencia/Municipio/ObterMunicipioPorId",
  listCountiesEndpoint: "/api/AreasAbrangencia/Municipio/ListarMunicipios",
  updateCityEndpoint: "/api/AreasAbrangencia/Municipio/AlterarMunicipio",
}

export default cityConfig;